export enum ResultsDataSource {
  DEFAULT = 0,
  ATHLINKS = 1,
  CTLIVE = 2
}

export interface IEventLinkInfoItem {
  athCourseId: number,
  athEventCourseId: number,
  athEventId: number,
  ctEventId: number,
  ctCourseId: number,
  resultsDataSource: ResultsDataSource
}

export interface IEventLinkInfo {
  links: IEventLinkInfoItem[]
}
